/* eslint-disable camelcase */
/* eslint-disable no-console */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { Dispatch } from 'redux';
import { actions } from '@state/modals';

let dispatch: Dispatch;

export const setDispatch = (d: Dispatch) => {
  dispatch = d;
};

export const handleError = (message: string, error: any, opt_callback?: () => void) => {
  // dispatches an error modal.
  // its on the error modal that the user sends sentry errors (if they allow for crash reports)
  if (dispatch) {
    dispatch({
      type: actions.MODALS_SET_MODAL,
      payload: {
        type: 'error-warning',
        message,
        error: { ...error, message },
        callback: opt_callback,
      },
    });
  } else {
    // otherwise just log
    console.log('dispatch not available', 'error', message, error);
  }
};
